import React, { useEffect } from "react";
import { Link } from "react-router-dom";
//import { Redirect } from 'react-router';

import Footer from "./Footer";
import Sidebar from "./Sidebar";
import Header from "./Header";
import {CAMPAIGN_CREATE_LINK, LOGIN_LINK} from './../constants/constants';
import client from "../api";

const HomePage = () => {
    useEffect(()=>{
        const user = localStorage.getItem('userinfo');
        const token = localStorage.getItem('token');
        const tokenPresent = !!(token && String(token).trim().length);
        const userPresent = user != null && String(user).trim().length > 0;
        if (!tokenPresent || !userPresent) {
            window.location.href = LOGIN_LINK;
            return;
        }
        const api = client();
        (async () => {
            try {
                const res = await api.get('/v1/user/me');
                if (res.status === 200 || res.status === 201) {
                    localStorage.setItem('userinfo', JSON.stringify(res.data.data));
                } else {
                    window.location.href = LOGIN_LINK;
                }
            } catch (e) {
                // Expired/invalid session: go to login (401 also handled in api interceptor, but avoid stale home shell)
                window.location.href = LOGIN_LINK;
            }
        })();
    },[]);
    return(<>
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="home-content">
                <div className="top-banner">
                    <h1>Welcome to <span>Panacea</span></h1>
                    <p>An easy approach for email outreach.</p>
                    <div className="cta-link">
                        <Link to={CAMPAIGN_CREATE_LINK} className="primary-btn"><i className="bx bx-plus"></i>New Campaign</Link>
                    </div>
                </div>
            </div>
        </div>
        <Footer/>
        </>);
}

export default HomePage;